import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { OximeterState } from "../../ProSimulator/OximeterSimulator";
import { colors } from "../../Style";
import { ALARM_CODE } from "../../ProSimulator/Alarm";
import { getHighestSeverityAlarm } from "../../ProSimulator/Alarm";
import { blink } from "../../Style";
import { translate, Translate } from "react-i18nify";
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
export const Spo2Component = (props) => {
  let color = props.color;
  let name = props.name;
  let unit = props.unit;
  let error = props.error;
  let value = props.value;
  let oximeter = props.pro?.oximeter;
  const [colorTextLowSpo2, setColorTextLowSpo2] = useState(colors().TEXT_COLOR);
  const [colorTextHighSpo2, setColorTextHighSpo2] = useState(colors().TEXT_COLOR);
  const [blinkSpeed, setBlinkSpeed] = useState("none");

  const [spo2Alarms, setSpo2Alarms] = useState(null);

  const [oximeterState, setOximeterState] = useState(oximeter?.state);

  const getTextColorFromAlarmSpO2 = (alarm) => {
    switch (alarm?.alarmCode) {
      case ALARM_CODE.CRITICALLY_LOW_SPO2:
        return colors().COLORS_ALARM_HIGH;
      case ALARM_CODE.VERY_LOW_SPO2:
        return colors().COLORS_ALARM_MEDIUM;
      case ALARM_CODE.LOW_SPO2:
        return colors().COLORS_ALARM_LOW;
      case ALARM_CODE.HIGH_SPO2:
        return colors().COLORS_ALARM_LOW;
      default:
        return colors().TEXT_COLOR;
    }
  };
  const getBlinkSpeedFromAlarmSpO2 = (alarm) => {
    switch (alarm?.alarmCode) {
      case ALARM_CODE.CRITICALLY_LOW_SPO2:
        return "0.5s";
      case ALARM_CODE.VERY_LOW_SPO2:
        return "1.0s";
      case ALARM_CODE.LOW_SPO2:
        return "none";
      case ALARM_CODE.HIGH_SPO2:
        return "0.5s";
      default:
        return colors().TEXT_COLOR;
    }
  };

  useEffect(() => {
    if (props.isManual) {
      setSpo2Alarms(null);
      setColorTextLowSpo2(getTextColorFromAlarmSpO2(colors().TEXT_COLOR));
      setColorTextHighSpo2(getTextColorFromAlarmSpO2(colors().TEXT_COLOR));
      setBlinkSpeed("none");
      return;
    }
    let highestAlarmSpo2 = getHighestSeverityAlarm(props.pro?.alarms, [
      ALARM_CODE.CRITICALLY_LOW_SPO2,
      ALARM_CODE.VERY_LOW_SPO2,
      ALARM_CODE.LOW_SPO2,
      ALARM_CODE.HIGH_SPO2,
    ]);
    if (highestAlarmSpo2 != 0) {
      setSpo2Alarms(highestAlarmSpo2);
    } else {
      setSpo2Alarms(null);
    }

    setColorTextLowSpo2(getTextColorFromAlarmSpO2(highestAlarmSpo2));
    setBlinkSpeed(getBlinkSpeedFromAlarmSpO2(highestAlarmSpo2));
  }, [props.pro?.alarms]);

  useEffect(() => {
    setOximeterState(oximeter?.state);
  }, [oximeter?.state]);
    
  const ErrorSection = () => {
    return(
    <Box
        sx={{
          width: "100%",
          mb:5.8,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          mt: 1,
        }}
      >
        <Typography
          variant="h5"
          sx={{
            display:
              spo2Alarms != null &&
              oximeterState == OximeterState.SIGNAL_DATA &&
              !props.isManual
                ? "block"
                : "none",
            color:
              colorTextLowSpo2 != colors().TEXT_COLOR
                ? colorTextLowSpo2
                : colorTextHighSpo2,
            fontWeight: "bold",
            animation: `${blink} ${blinkSpeed} infinite`,
          }}
        >
        {translate(spo2Alarms?.name)}
      </Typography>
    </Box>)
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "start",
      }}
    >
    {
      !props.showVital ? 
        //NO VITALS DISPLAY--------------------------------------------------------------------------------------------------------------------------------------------
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "end",
          }}
          name="comonmand"
        >
          <Box
          sx={{
            width: "100%",
            height: "23.5%",
            display: "flex",
            justifyContent: "center",
          }}
          align="center"
          name="innerBox"
          >
            <Typography
              variant="h5"
              sx={{
                color: colors().COLORS_ALARM_LOW,
                display: props.isManual ? "flex" : "none",
                fontWeight: "bold",
              }}
              name="typo"
            >
              <Translate value="ManualMode" />
            </Typography>
          </Box>
          {/* <ErrorSection/>         */}
        </Box>        
      :
        //SHOW VITALS DISPLAY--------------------------------------------------------------------------------------------------------------------------------------------
        <>
          <Box
            sx={{
              width: "100%",
              height: "16%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
            }}
          >
            <Typography sx={{ color: colors().TEXT_COLOR }} variant="h6">
              {name}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                position: "absolute",
                right: "100px",
                top: "20px",
                color: "gray",
              }}
            >
              {unit}
            </Typography>
          </Box>
          <Box
            sx={{
              width: "75%",
              height: "35%",
              display: "flex",
              flexDirection: "column",
              border: "2px solid " + color,
              borderRadius: "25px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {oximeterState == OximeterState.WEAK_SIGNAL 
              ? <DoDisturbIcon
                  sx={{
                    color: colors().COLORS_ALARM_LOW,
                    position: "absolute",
                    top: "60px",
                    right: "120px"
                  }}
                />
              : <></>
            }
            {oximeterState == OximeterState.SIGNAL_DATA || oximeterState == OximeterState.WEAK_SIGNAL ? (
                <Typography
                  variant="h2"
                  sx={{
                    color:
                    colorTextLowSpo2 != colors().TEXT_COLOR
                    ? colorTextLowSpo2
                    : colorTextHighSpo2,
                    position: "absolute"
                  }}
                  >

                  {value?.toFixed(props.decimalPoints)}
                </Typography>
              
            ) : (
              <Typography variant="h2" sx={{ color: colors().TEXT_COLOR }}>
                ---
              </Typography>
            )}
          </Box>
          <Box
            sx={{
              width: "2px",
              height: "8%",
              display: "flex",
              flexDirection: "row",
              background: color,
              justifyContent: "center",
            }}
          ></Box>
          <Box
            sx={{
              width: "100%",
              height: "15%",
              display: "flex",
              flexDirection: "row",
              border: "2px solid " + color,
              borderRadius: "20px",
              justifyContent: props.isManual ? "center" : "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                ml: 2,
                color:
                  oximeterState != OximeterState.SIGNAL_DATA
                    ? colors().TEXT_COLOR
                    : colorTextLowSpo2,
                display: props.isManual ? "none" : "flex",
              }}
            >
              {props?.min}
            </Typography>
            <Typography
              variant="h5"
              sx={{
                color: colors().COLORS_ALARM_LOW,
                display: props.isManual ? "flex" : "none",
                fontWeight: "bold",
              }}
            >
              <Translate value="ManualMode" />
            </Typography>
            <Typography
              variant="h5"
              sx={{
                mr: 2,
                color:
                  oximeterState != OximeterState.SIGNAL_DATA 
                    ? colors().TEXT_COLOR
                    : colorTextHighSpo2,
                display: props.isManual ? "none" : "flex",
              }}
            >
              {props?.max}
            </Typography>
          </Box>
          <ErrorSection/>
          {/* <Box
            sx={{
              width: "100%",
              height: "18%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                display:
                  spo2Alarms != null &&
                  oximeterState == OximeterState.SIGNAL_DATA &&
                  !props.isManual
                    ? "block"
                    : "none",
                color:
                  colorTextLowSpo2 != colors().TEXT_COLOR
                    ? colorTextLowSpo2
                    : colorTextHighSpo2,
                fontWeight: "bold",
                animation: `${blink} ${blinkSpeed} infinite`,
              }}
            >
              {translate(spo2Alarms?.name)}            
            </Typography>
          </Box> */}
        </>
    }
    </Box>
  );

};

  // const ErrorSection = (props) => {
  //   <Box
  //       sx={{
  //         width: "100%",
  //         mb:5.8,
  //         display: "flex",
  //         flexDirection: "row",
  //         alignItems: "center",
  //         justifyContent: "center",
  //       }}
  //     >
  //       <Typography
  //         variant="h5"
  //         sx={{
  //           display:
  //             props?.spo2Alarms != null &&
  //             props?.oximeterState == OximeterState.SIGNAL_DATA &&
  //             !props.isManual
  //               ? "block"
  //               : "none",
  //           color:
  //             props?.colorTextLowSpo2 != colors().TEXT_COLOR
  //               ? props?.colorTextLowSpo2
  //               : props?.colorTextHighSpo2,
  //           fontWeight: "bold",
  //           animation: `${props?.blink} ${props?.blinkSpeed} infinite`,
  //         }}
  //       >
  //       {translate(props?.spo2Alarms?.name)}
  //     </Typography>
  //   </Box>

  // }

